import React, {useEffect, useState} from 'react';
import './App.scss';
import Header from './Components/Header';
import Overview from './Components/Overview';
import Configurator from './Components/Configurator';
import Technical from './Components/Technical';
import Footer from './Components/Footer';
import Modal from './Components/Modal';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fab, faFacebookSquare, faLinkedin, faYoutubeSquare } from '@fortawesome/free-brands-svg-icons';
import { fal, faInfoCircle } from '@fortawesome/pro-light-svg-icons';

library.add(fab, fal, faInfoCircle, faFacebookSquare, faLinkedin, faYoutubeSquare)

function App() {
  
  const [modalToggle, setModalToggle] = useState("")
  const [modalView, setModalView] = useState("")
  const [downloadCode, setDownloadCode] = useState("")
  const [modalName, setModalName] = useState("")

  const modalToggler = (view, code, name) => {
    if (modalToggle === "active") {
      setModalView("")
      setDownloadCode("")
      setModalName("")
      setModalToggle("")
    } else {
      setModalView(view)
      setDownloadCode(code)
      setModalName(name)
      setModalToggle("active")
    }
  }

  //Set the window size state to maintain media queries
  const [windowSize, setWindowSize] = useState(() => {
    if (window.matchMedia("(min-width: 950px)").matches) {
      return 'Web'
    } else if (window.matchMedia("(min-width: 500px)").matches) {
      return 'Tablet'
    } else {
      return 'Mobile'
    }
  })

  useEffect (() => {

    const handleResize = () => {
      let size = ''
      if (window.matchMedia("(min-width: 950px)").matches) {
        size = 'Web'
      } else if (window.matchMedia("(min-width: 500px)").matches) {
        size = 'Tablet'
      } else {
        size = 'Mobile'
      }

      if (size !== windowSize) {
        setWindowSize(size)
      }
    }
    
    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }) 

  const [webp, setWebp] = useState("webp")

	useEffect (() => {

		let kTestImages = {
				lossy: "UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA",
				lossless: "UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==",
				alpha: "UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==",
				animation: "UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA"
		};
		let img = new Image();
		img.onload = function () {
				let result = (img.width > 0) && (img.height > 0);
				if (result) {
					setWebp("webp")
				} else {
					setWebp("nowebp")
				}
		};
		img.onerror = function () {
			setWebp("nowebp")
		};
		img.src = "data:image/webp;base64," + kTestImages["lossy"];

  }, []) 

  return (
    <div className="App">
      <Header 
        windowSize={windowSize}
        webP={webp}
      />
      <Overview 
        windowSize={windowSize}
        modalToggler={modalToggler}
        webP={webp}
      />
      <Configurator 
        windowSize={windowSize}
        modalToggler={modalToggler}
      />
      <Technical 
        windowSize={windowSize}
        modalToggler={modalToggler}
      />
      <Footer 
        windowSize={windowSize}
      />
      <Modal
        windowSize={windowSize}
        visible={modalToggle}
        view={modalView}
        code={downloadCode}
        name={modalName}
        modalToggler={modalToggler}
      />
    </div>
  );
}

export default App;
